module.exports = __webpack_public_path__ + "media/images/plans/plan-detail-photo-bouquet-4-4f06fd2f077e38296c193a66d34eebbe.jpg";